import { createElementBlock as n, openBlock as o, createElementVNode as l } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(d, e) {
  return o(), n("svg", r, e[0] || (e[0] = [
    l("path", {
      fill: "#F5F5F5",
      "fill-rule": "evenodd",
      d: "M4 1h12l4 3.5V23H4z",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "#1E0046",
      "fill-rule": "evenodd",
      d: "M13.353 8.75c-1.22 0-2.284.686-2.83 1.7h1.808a.75.75 0 1 1 0 1.5h-2.197V12q0 .3.051.583h2.146a.75.75 0 1 1 0 1.5h-1.45a3.204 3.204 0 0 0 4.617.341.75.75 0 1 1 1.004 1.114 4.7 4.7 0 0 1-3.149 1.212 4.72 4.72 0 0 1-4.242-2.667H8a.75.75 0 1 1 0-1.5h.669A5 5 0 0 1 8.634 12v-.05H8a.75.75 0 0 1 0-1.5h.89a4.72 4.72 0 0 1 4.463-3.2c1.21 0 2.315.46 3.15 1.212a.75.75 0 0 1-1.005 1.113 3.2 3.2 0 0 0-2.145-.825",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const a = { render: t };
export {
  a as default,
  t as render
};
//# sourceMappingURL=ic_invoice_euro-C2VLGL2U.js.map
